<template>
  <div>
    <div class="text-center">
      <h2 v-if="!form_type" class="mt-6 text-3xl font-extrabold text-gray-300">
        Login
      </h2>
      <h2
        v-if="form_type == 'SMS_MFA' || form_type === 'SOFTWARE_TOKEN_MFA'"
        class="mt-6 text-3xl font-extrabold text-gray-300"
      >
        Autenticação por SMS
      </h2>
      <h2
        v-if="form_type == 'NEW_PASSWORD_REQUIRED'"
        class="mt-6 text-3xl font-extrabold text-gray-300"
      >
        Nova senha
      </h2>

      <p v-if="!form_type" class="mt-2 text-sm text-gray-400">
        Acesse sua conta
      </p>
      <p
        v-if="form_type == 'SMS_MFA' || form_type === 'SOFTWARE_TOKEN_MFA'"
        class="mt-2 whitespace-normal text-sm text-gray-400"
      >
        Um código será enviado para seu telefone cadastrado na Ontick.
        {{ details_sms.CODE_DELIVERY_DESTINATION }}
      </p>
    </div>
    <div
      is="transition"
      v-on:enter="enter"
      v-on:leave="leave"
      v-bind:css="false"
      appear
      mode="out-in"
    >
      <div :key="1" v-if="!form_type" class="mt-6 space-y-6">
        <ontick-input
          placeholder="ontick@ontick.com.br"
          v-model="user.email"
          label="Email"
          name="email"
          type="email"
          v-validate="'required|email'"
          :error="errors.first('email')"
          bg="bg-ontick-steel-500 text-gray-300"
        ></ontick-input>

        <div class="relative pb-6">
          <ontick-input
            @keyup.enter.native="login()"
            placeholder="**********"
            v-model="user.password"
            label="Senha"
            :type="visibled ? 'text' : 'password'"
            name="password"
            v-validate="'required'"
            :error="errors.first('password')"
            bg="bg-ontick-steel-500 text-gray-300"
          ></ontick-input>

          <span
            @click="visibled = !visibled"
            class="absolute inset-y-7 z-10 cursor-pointer text-gray-300 transition-all duration-150"
            :class="errors.has('password') ? 'right-10' : 'right-2'"
            v-html="visibled ? $icons.eye : $icons.eye_off"
          ></span>
        </div>

        <div id="grecaptcha" class="hidden"></div>

        <ontick-button @click.native="login" class="w-full">
          <span v-show="!loading_buttons">Continuar</span>
          <span v-show="loading_buttons" v-html="$icons.loading"></span>
        </ontick-button>
        <div class="space-y-6 text-center">
          <a
            @click="$emit('selectedRemember', true)"
            class="cursor-pointer text-sm text-gray-300 hover:text-gray-400"
          >
            Esqueci minha senha
          </a>
          <div class="border border-ontick-steel-500"></div>
          <div class="text-sm">
            <p class="text-gray-300">Ainda não possui uma conta?</p>
            <p
              @click="$emit('register')"
              class="cursor-pointer font-medium text-ontick-blue-600"
            >
              Faça seu cadastro
            </p>
          </div>
        </div>
      </div>
      <div
        :key="2"
        v-else-if="form_type == 'SMS_MFA' || form_type === 'SOFTWARE_TOKEN_MFA'"
      >
        <div
          is="transition"
          v-on:enter="enter"
          v-on:leave="leave"
          v-bind:css="false"
          appear
          mode="out-in"
        >
          <div :key="2" v-if="!validate_sms" class="space-y-6">
            <label for="code" class="block text-sm font-medium text-gray-300">
              Código
            </label>
            <div class="mt-1">
              <PinCodeInput
                v-model="code"
                :secure="false"
                :characterPreview="false"
                :length="6"
                name="code"
                v-validate="'required'"
                :error="errors.first('code')"
              />
              <p
                class="text-xs text-ontick-red-500"
                v-show="errors.has('code')"
              >
                Campo obrigatório
              </p>
            </div>

            <ontick-button @click.native="confirmSignIn()" class="my-6 w-full">
              <span v-show="!loading_buttons">Validar</span>
              <span v-show="loading_buttons" v-html="$icons.loading"></span>
            </ontick-button>
          </div>

          <div :key="3" v-else class="flex justify-center">
            <div>
              <success-icon
                :active="validate_sms"
                title=" Telefone validado com sucesso"
              />
            </div>
          </div>
        </div>
      </div>
      <div :key="3" v-else-if="form_type == 'NEW_PASSWORD_REQUIRED'">
        <div class="space-y-6" v-if="!new_password_status">
          <password-validate
            label="Nova senha"
            ref="new_password"
            name="new_password"
            v-model="new_password"
            v-validate="'required'"
            :error="errors.first('new_password')"
          />

          <ontick-button @click.native="newPassword()" class="w-full">
            <span v-show="!loading_buttons">Alterar</span>
            <span v-show="loading_buttons" v-html="$icons.loading"></span>
          </ontick-button>
        </div>
        <div v-if="new_password_status" class="flex justify-center">
          <div class="py-16">
            <success-icon
              :active="new_password_status"
              title="Senha alterada com sucesso"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Auth } from "aws-amplify";
import PinCodeInput from "vue-pincode-input";
import PasswordValidate from "./password.validate.component.vue";
import VueRecaptcha from "vue-recaptcha";
import SuccessIcon from "@/app/shared/components/basic/ontick-success.component.vue";
import EventBus from "../../../shared/utils/event_bus";
import axios from "axios";

export default {
  components: {
    PinCodeInput,
    PasswordValidate,
    VueRecaptcha,
    SuccessIcon,
  },
  data() {
    return {
      user: {
        email: "",
        password: "",
        details: {},
      },

      new_password: "",
      new_password_status: false,

      visibled: false,

      code: "",
      validate_sms: false,
      details_sms: {},

      form_type: null,

      loading_buttons: false,
    };
  },

  methods: {
    enter(el, done) {
      TweenMax.fromTo(
        el,
        1,
        {
          autoAlpha: 0,
          scale: 1.5,
        },
        {
          autoAlpha: 1,
          scale: 1,
          transformOrigin: "50% 50%",
          ease: Power4.easeOut,
          onComplete: done,
        }
      );
    },
    leave(el, done) {
      TweenMax.fromTo(
        el,
        1,
        {
          autoAlpha: 1,
          scale: 1,
        },
        {
          autoAlpha: 0,
          scale: 0.8,
          ease: Power4.easeOut,
          onComplete: done,
        }
      );
    },

    verifyRecaptcha() {
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.$refs.recaptcha.execute();
        }
      });
    },

    login() {
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.loading_buttons = true;
          Auth.signIn(this.user.email, this.user.password)
            .then((response) => {
              this.form_type = response.challengeName;
              this.details_sms = response.challengeParam;
              this.user.details = response;
              if (
                this.form_type == "SMS_MFA" ||
                this.form_type == "SOFTWARE_TOKEN_MFA" ||
                this.form_type == "NEW_PASSWORD_REQUIRED"
              ) {
                this.$emit("options", true);
              } else {
                this.$router.push({
                  name: "Dashboard",
                  query: { ...this.$route.query },
                });
              }
            })
            .then(() => {
              EventBus.$emit("LOGIN_SUCCESSFUL");
            })
            .catch((error) => {
              this.$swal({
                title: error.message,
                icon: "error",
                timer: 5000,
              });
            })
            .finally(() => {
              this.loading_buttons = false;
            });
        }
      });
    },

    confirmSignIn() {
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.loading_buttons = true;

          Auth.confirmSignIn(this.user.details, this.code)
            .then(() => {
              this.validate_sms = true;
              setTimeout(() => {
                this.$router.push({
                  name: "Dashboard",
                  query: { ...this.$route.query },
                });
              }, 4000);
            })
            .catch((error) => {
              this.$swal({
                title: error.message,
                icon: "error",
                timer: 5000,
              });
            })
            .finally(() => {
              this.loading_buttons = false;
            });
        }
      });
    },

    newPassword() {
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.loading_buttons = true;

          Auth.completeNewPassword(this.user.details, this.new_password)
            .then(() => {
              this.new_password_status = true;
              setTimeout(() => {
                this.$router.push({
                  name: "Dashboard",
                  query: { ...this.$route.query },
                });
              }, 5000);
            })
            .catch((error) => {
              this.$swal({
                title: error.message,
                icon: "error",
                timer: 5000,
              });
            })
            .finally(() => {
              this.loading_buttons = false;
            });
        }
      });
    },

    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
    },
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.9s ease;
  overflow: hidden;
  visibility: visible;
  //   position: absolute;
  //   width: 100%;
  opacity: 1;
}

.fade-enter,
.fade-leave-to {
  visibility: hidden;
  position: absolute;

  width: 100%;
  opacity: 0;
}
</style>
